import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  AI

  <span style="color:#85c1dc;">**FI:**</span>
  AI

  <span style="color:#85c1dc;">**RU:**</span>
  AI
*/
/* @__NO_SIDE_EFFECTS__ */
const m1666 = msg(
  mf`AI`,
  mf`AI`,
  mf`AI`,
)

export { m1666 as 'w.module.miros.button' }